'use client';

// Spanish copy of components/platformAbout for /es/platforms/<slug>
// (DEV-15362, ES batch 2). Same layout and styles.
import React from 'react';
import Link from 'next/link';
import { StyledWidgetDiv } from '../platformAbout/platformAbout.styles';
import { IPlatform } from '../../types';

interface IPlatformAboutEsProps {
    platform: Pick<IPlatform, 'title' | 'desc' | 'link'>;
}

export const PlatformAboutEs = ({ platform }: IPlatformAboutEsProps) => {
    return (
        <StyledWidgetDiv>
            <h2>Acerca de {platform.title}</h2>
            <div className="p" dangerouslySetInnerHTML={{ __html: platform.desc.replaceAll('\n', '<br>') }} />
            {platform.link && (
                <div className="platform-link-wrapper">
                    <p>Visita</p>
                    <Link target="_blank" rel="nofollow" href={platform.link}>
                        {platform.title}
                    </Link>
                </div>
            )}
        </StyledWidgetDiv>
    );
};
